// import React from 'react';
// import '../lib/animate/animate.min.css';
// import { FaYoutube } from 'react-icons/fa';
// const Footer=()=> {
//   return (
//     <div class="footer wow fadeIn" data-wow-delay="0.3s" style={{backgroundColor:"#343148"}}>
//             <div class="container-fluid">
//                 <div class="container">
//                     <div class="footer-info">
//                         <img style={{marginLeft:'-23px'}}src="star.png"/><br/>
//                         <a href="/" class="footer-logo"><span></span><h2 style={{color: "white", fontSize:"38px"}}><b>AnantaSaukhyam</b></h2></a><br/>
//                         <img style={{marginLeft:'-23px',height:'50px'}}src="logo9991.png"/><br/>
//                         <div class="">
//                             <p style={{fontSize:"25px",color:"white"}}>+916366889406</p>
                            

//                             <a href="mailto:info@anantasaukhyam.com" style={{color:"white",fontSize:"20px"}}><b>info@anantasaukhyam.com</b></a>
//                         </div>
//                         <div class="footer-social">
//                             {/* <a href=""><i class="fab fa-twitter"></i></a> */}
                           
//                             <a href="https://www.youtube.com/watch?v=0VXeYTuFEmk" target="_blank"><FaYoutube size={30} color={"white"} /></a>
                        
//                         </div>
//                     </div>
//                 </div>
//                 <div class="container copyright">
//                     <div class="row">
//                         <div class="col-md-6">
//                             <p>&copy; <a href="#"><b>2024 AnantaSaukhyam</b></a>, All Rights Reserved.</p>
//                         </div>
//                         <div class="col-md-6">
							
//                             <p>Designed By <a href="https://www.excerptech.com/" target='_blank'> <b>Excerpt Technologies Pvt Ltd</b></a></p>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//   )
// }

// export default Footer;


import React from 'react';
import '../lib/animate/animate.min.css';
import { FaYoutube } from 'react-icons/fa';

const Footer = ({ className = '' }) => {
  return (
    <div className={`footer wow fadeIn ${className}`} data-wow-delay="0.3s" style={{ backgroundColor: "#343148" }}>
      <div className="container-fluid">
        <div className="container"  style={{position:"relative"}} >
          <div className="footer-info text-center">
            <img style={{ marginLeft: '-23px' }} src="star.png" alt="star" /><br />
            <a href="/" className="footer-logo">
              <h2 style={{ color: "white", fontSize: "38px" }}><b>AnantaSaukhyam</b></h2>
            </a><br />
            <img style={{ marginLeft: '-23px', height: '50px' }} src="logo9991.png" alt="logo" /><br />

            <p style={{ fontSize: "25px", color: "white" }}>+91 63668 89406</p>
            <a href="mailto:info@anantasaukhyam.com" style={{ color: "white", fontSize: "20px" }}>
              <b>info@anantasaukhyam.com</b>
            </a>

            <div className="footer-social mt-3">
              <a href="https://www.youtube.com/watch?v=0VXeYTuFEmk" target="_blank" rel="noopener noreferrer">
                <FaYoutube size={30} color={"white"} />
              </a>
            </div>
          </div>

          {/* Location Section */}
          <div className="footer-locations" style={{ display: "flex", justifyContent: "space-between", color: "white", marginTop: "40px", flexWrap: "wrap", }}>
            
            {/* Left side - Two India Locations */}
            <div style={{ flex: "1", minWidth: "280px",marginTop:"-300px"}}>
              {/* <div style={{ marginBottom: "25px",marginTop:"-300px"            
               }}>
                <h4 style={{ color: "#00d9ff" }}>Bengaluru - Kalyan Nagar</h4>
                <p>2nd Floor, Nagasri Arcade, 89/1, Service Rd,<br />above Kalyani Motors, Chellikere,<br />Kalyan Nagar, Bengaluru, Karnataka 560043</p>
                <p><b>Phone:</b> 080500 58766</p>
              </div> */}

              <div>
                <h4 style={{ color: "#00d9ff" }}>Bengaluru - Domlur</h4>
                <p>50, first floor 1st cross 1st Main Road Domlur layout,<br /> Domlur , Bengaluru,<br />Karnataka 560071, India</p>
                <p><b>Phone:</b> 063668 89406</p>
              </div>
            </div>

            {/* Right side - UK Location */}
            <div style={{ flex: "1", minWidth: "280px", textAlign: "right", marginTop:"-300px"   }}>
              <h4 style={{ color: "#00d9ff" }}>United Kingdom</h4>
              <p>15 Elbe Way,<br />Andover, SP10 4LD, Hants, UK.</p>
              <p><b>Phone:</b> +44 7809 705833</p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="container copyright" style={{ marginTop: "30px" }}>
          <div className="row">
            <div className="col-md-6">
              <p>&copy; <b>2024 AnantaSaukhyam</b>, All Rights Reserved.</p>
            </div>
            <div className="col-md-6 text-md-right">
              <p>Designed By <a href="https://www.excerptech.com/" target="_blank" rel="noopener noreferrer" style={{ color: "white" }}><b>Excerpt Technologies Pvt Ltd</b></a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
